import { useAuthStore } from 'src/common/store'
import { onSignalREvent } from '../../signalRBus'
import {
  useClientContextStore,
  useClientMessagingStore,
} from 'src/client/stores'
import { useLoader } from '../../../hooks/useLoader'
import { APIS, LOADERS } from 'src/config/constants'
import { IMessage } from 'src/interfaces/common'
import { SIGNAL_R_MESSAGES, SIGNAL_R_SCOPES } from 'src/signalR/types'

type ParentPortalUnreadMessagesCount = Record<string, number>

onSignalREvent(
  SIGNAL_R_SCOPES.system,
  SIGNAL_R_MESSAGES.getParentPortalUnreadMessages,
  (text) => {
    const authStore = useAuthStore()
    if (!authStore.isClient) return

    const messagingStore = useClientMessagingStore()
    if (messagingStore.useNewMessaging) return
    const clientContextStore = useClientContextStore()

    const { useFetchLoader: fetchParentPortalUnreadMessagesCount } =
      useLoader<ParentPortalUnreadMessagesCount>(LOADERS.per, {
        uri: 'parentPortalUnreadMessagesCount',
      })

    const [orgId, centerId, memberId] = text.split('_')
    if (
      clientContextStore.orgId === orgId &&
      clientContextStore.centerId === centerId &&
      clientContextStore.loggedInMember
    ) {
      if (clientContextStore.loggedInMember.id !== memberId) return
      void fetchParentPortalUnreadMessagesCount().then((result) => {
        messagingStore.setUnreadMessages(result ?? {})
      })
      if (clientContextStore.loggedInMember.id) {
        const opts = { params: { updateActivity: false } }
        const { useFetchLoader } = useLoader<IMessage[]>(LOADERS.per, {
          uri: `${APIS.members}/${clientContextStore.loggedInMember.id}/${APIS.messages}`,
        })
        void useFetchLoader(opts).then((result) =>
          messagingStore.setMessages(result ?? []),
        )
      }
    }
  },
)
